"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelScrollManager = void 0;
var event_dispatcher_1 = require("../../base-utils/event-dispatcher");
var ModelScrollManager = (function () {
    function ModelScrollManager() {
        this.onChanged = new event_dispatcher_1.EventDispatcher();
        this.init();
    }
    ModelScrollManager.prototype.setScroll = function (state) {
        this.state = state;
    };
    ModelScrollManager.prototype.init = function () {
        this.state = null;
    };
    ModelScrollManager.prototype.raiseOnChanged = function () {
        this.onChanged.listeners.forEach(function (listener) { return listener.NotifyScrollChanged(); });
    };
    ModelScrollManager.StandartScrollPosition = -1;
    ModelScrollManager.DontChangeScrollPosition = -2;
    return ModelScrollManager;
}());
exports.ModelScrollManager = ModelScrollManager;
